import { ArrowLeftIcon, ArrowRightIcon } from '@persona-id/design-tokens/icons';
import { Ref } from 'react';
import { AriaCalendarProps, DateValue, useCalendar, useLocale } from 'react-aria';
import { useCalendarState } from 'react-stately';

import {
  CalendarButton,
  CalendarContainer,
  CalendarHeader,
  CalendarHeading,
} from 'design-system/components/DatePicker/Calendar/CalendarBase';
import CalendarGrid from 'design-system/components/DatePicker/Calendar/CalendarGrid';
import { createCalendar } from 'design-system/components/DatePicker/common';

interface CalendarProps extends AriaCalendarProps<DateValue> {
  calendarRef?: Ref<HTMLDivElement>;
}

const Calendar = (props: CalendarProps) => {
  const { locale } = useLocale();
  const state = useCalendarState({ ...props, locale, createCalendar });
  const { calendarProps, prevButtonProps, nextButtonProps, title } = useCalendar(props, state);

  return (
    <CalendarContainer {...calendarProps} ref={props.calendarRef}>
      <CalendarHeader>
        <CalendarButton {...prevButtonProps}>
          <ArrowLeftIcon />
        </CalendarButton>
        <CalendarHeading>{title}</CalendarHeading>
        <CalendarButton {...nextButtonProps}>
          <ArrowRightIcon />
        </CalendarButton>
      </CalendarHeader>
      <CalendarGrid state={state} />
    </CalendarContainer>
  );
};

export default Calendar;
